import React, { FC } from 'react'
import { Box, BoxProps, Grid } from 'transfix-ui/core'

interface IResponsiveLayoutRowProps {
  /**
   * Make the row full width - no horizontal padding
   * @default false
   */
  fluid?: boolean
  /**
   * Allow `<Box />` customization
   */
  BoxProps?: BoxProps
}

export const ResponsiveLayoutRow: FC<IResponsiveLayoutRowProps> = ({
  fluid = false,
  children,
  BoxProps = {},
}) => {
  const initialPx = fluid ? 0 : 2
  const { px: pxProp } = BoxProps || {}
  const px = typeof pxProp === 'number' ? pxProp : 0
  const padding: number = initialPx + px

  return (
    <Box {...BoxProps} px={padding}>
      <Grid container>
        <Grid item xs={12}>
          {children}
        </Grid>
      </Grid>
    </Box>
  )
}
